import Briza1 from "./7x16 (1).webp";
import Briza2 from "./7x16 (2).webp";
import Briza3 from "./7x16 (3).webp";
import Briza4 from "./7x16 (4).webp";
import Briza5 from "./7x16 (5).webp";
import Briza6 from "./7x16 (6).webp";
import Briza7 from "./7x16 (7).webp";
import Briza8 from "./7x16 (8).webp";
import Briza9 from "./7x16 (9).webp";

const Briza7Atticimages = [
  Briza1,
  Briza2,
  Briza3,
  Briza4,
  Briza5,
  Briza6,
  Briza7,
  Briza8,
  Briza9,
];

export default Briza7Atticimages;
